import axios from 'axios'

const api = () => {
  return axios.create({
    baseURL: process.env.API_ENDPOINT
  })
}
const state = {
  items: [],
  item: [],
  customerItems: [],
  pos: [],
  updated: []
}
const mutations = {
  GET_ITEMS (state, payload) {
    state.items = payload
  },
  GET_ITEM (state, payload) {
    state.item = payload
  },
  GET_POS (state, payload) {
    state.pos = payload
  },
  GET_CUSTOMER_ITEMS (state, payload) {
    state.customerItems = payload
  },
  GET_UPDATED (state, payload) {
    state.updated = payload
  }
}
const actions = {
  // Get Items
  getItems ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api().get('items').then((response) => {
        commit('GET_ITEMS', response.data.items)
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  // Get Single Item
  getItem ({ commit }, item) {
    let itemAdd = 'item/' + item.ItemNo
    return new Promise((resolve, reject) => {
      api().get(itemAdd)
        .then((response) => {
          commit('GET_ITEM', response.data.item)
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },
  getPos ({ commit }, item) {
    let poAdd = 'po/' + item
    return new Promise((resolve, reject) => {
      api().get(poAdd)
        .then((response) => {
          commit('GET_POS', response.data.po)
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },
  getUpdated ({ commit }) {
    return new Promise((resolve, reject) => {
      api().get('updated').then((response) => {
        commit('GET_UPDATED', response.data.updated)
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  }
}
const getters = {
  items: state => state.items,
  item: state => state.item,
  customerItems: state => state.customerItems,
  pos: state => state.pos,
  updated: state => state.updated
}
const methods = {
}
const itemModule = {
  state,
  mutations,
  actions,
  methods,
  getters
}

export default itemModule
